import React from 'react';
import { type App } from 'generated/graphql';
import { getConnectUrl } from 'utils';
import { AppsList } from 'components/AppsList/AppsList';
import styles from './NoMenus.module.scss';

interface Props {
  apps: App[];
  venueId?: string;
}

export const SupportedApps: React.FC<Props> = ({ apps, venueId }) => {
  const getAppUrl = (app: App): string => {
    return getConnectUrl(venueId, `apps/${app.id}`);
  };

  return (
    <section aria-labelledby="supported-apps" className={styles.SupportedApps}>
      <div className={`${styles.Cont} container`}>
        <h3 id="supported-apps">Supported apps</h3>
        <AppsList getUrl={getAppUrl} apps={apps} showLabel />
      </div>
    </section>
  );
};

export default SupportedApps;
